export default __webpack_public_path__ + "static/media/192.da2b86dd.jpg";